import { useInfiniteQuery } from '@tanstack/react-query';
import { ICandidateListViewEntity, IGetCandidateListPayload } from '../types';
import { PermanentJobsService } from '../services';

interface IUseGetCandidateListInfiniteOptions {
  enabled?: boolean;
}

export const useGetCandidateListInfinite = (
  payload: Omit<IGetCandidateListPayload, 'page'>,
  options?: IUseGetCandidateListInfiniteOptions,
) => {
  const limit = payload.limit || 10;

  const { data, error, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError } =
    useInfiniteQuery({
      queryKey: [
        'GET_CANDIDATE_LIST_INFINITE',
        payload.jobPostingId,
        payload.limit,
        payload.orderBy,
        payload.orderDirection,
        payload.status,
      ],
      queryFn: async ({ pageParam = 1 }) =>
        PermanentJobsService.getCandidateList({
          ...payload,
          limit,
          page: pageParam,
        }),
      getNextPageParam: (lastPage) => {
        const { page, totalPages } = lastPage.pagination;
        return page < totalPages ? page + 1 : undefined;
      },
      initialPageParam: 1,
      enabled: options?.enabled ?? true,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 0,
    });

  // Flatten all pages into single array
  const allCandidates: ICandidateListViewEntity[] = data?.pages.flatMap((page) => page.data) ?? [];

  return {
    data: allCandidates,
    error,
    isError,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  };
};
